// extracted by mini-css-extract-plugin
module.exports = {"avatar":"styles__avatar___J2VVP","icon":"styles__icon___1vDSF"};